import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    mainView: {
      ...CommonStyles.full_flex,
      backgroundColor: colors.background,
      ...CommonStyles.pt_56,
      ...CommonStyles.pb_56,
    },
    input: {
      ...CommonStyles.mt_32,
      ...CommonStyles.max_width_292,
    },
    continueButton: {
      ...CommonStyles.full_flex,
      ...CommonStyles.mt_16,
    },
    backPressable: {
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
      ...CommonStyles.mb_32,
    },
    modalView: {
      ...CommonStyles.max_width_327,
      ...CommonStyles.p_24,
    },
    bottomModalView: {
      ...CommonStyles.max_width_327,
      ...CommonStyles.br_16,
    },
    bottomModalTitle: {
      ...CommonStyles.font_18,
      ...CommonStyles.mb_8,
    },
  });

export default makeStyles;
